// Translations for Bright FL Inspections — English + Spanish (formal "usted" tone)
export const translations = {
  en: {
    // Navbar
    "nav.home": "Home",
    "nav.about": "About",
    "nav.appointment": "Request Appointment",
    "nav.contact": "Contact",
    "nav.cta_appointment": "Request Appointment",

    // Footer
    "footer.tagline": "Illuminating every corner of your investment.",
    "footer.subtitle": "Licensed, insured residential inspections across Southwest Florida and surrounding areas.",
    "footer.navigate": "Navigate",
    "footer.contact": "Contact",
    "footer.area": "Southwest Florida & Surrounding Areas",
    "footer.rights": "All rights reserved.",
    "footer.creds": "FL Licensed • Insured • Certified",

    // Home — Hero
    "home.hero.overline": "Illuminating Your Investment",
    "home.hero.title1": "Florida home",
    "home.hero.title2": "inspections,",
    "home.hero.title3": "done right.",
    "home.hero.subtitle": "Bright FL Inspections delivers thorough, expert-written reports for homeowners, buyers, and insurers across Southwest Florida.",
    "home.hero.cta1": "Request an Appointment",
    "home.hero.cta2": "Our Services",
    "home.hero.badge1": "Licensed & Insured",
    "home.hero.badge2": "Certified Inspector",
    "home.hero.badge3": "48-hr Reports",
    "home.hero.badge4": "Serving SWFL",

    // Home — Services
    "home.services.overline": "What we inspect",
    "home.services.title": "Every report. Every angle. Every time.",
    "home.services.cta": "Get a Quote",
    "home.services.4pt.tag": "Insurance Ready",
    "home.services.4pt.title": "Four Point Inspection",
    "home.services.4pt.copy": "Roof, electrical, plumbing & HVAC — the four pillars insurers require for homes 25+ years old.",
    "home.services.wind.tag": "Save on Premiums",
    "home.services.wind.title": "Wind Mitigation",
    "home.services.wind.copy": "Document wind-resistant features to unlock major homeowner insurance discounts.",
    "home.services.full.tag": "Most Comprehensive",
    "home.services.full.title": "Full Home Inspection",
    "home.services.full.copy": "Top-to-bottom property evaluation for buyers, sellers, and new builds.",
    "home.services.roof.tag": "Roof Condition Certificate",
    "home.services.roof.title": "Roof Inspection",
    "home.services.roof.copy": "Insurance-grade roof condition reports — documentation underwriters accept.",

    // Home — Why
    "home.why.overline": "Why Bright FL",
    "home.why.title1": "Precision over",
    "home.why.title2": "paperwork.",
    "home.why.body": "We're built on a simple promise: every inspection is treated like it's our own home. Detailed. Honest. On time.",
    "home.why.item1.title": "Same-day on-site walkthrough",
    "home.why.item1.copy": "We review every finding with you before we leave the property.",
    "home.why.item2.title": "Reports in 48 hours or less",
    "home.why.item2.copy": "Photo-rich, easy-to-read PDFs — formatted for buyers, sellers, and insurers.",
    "home.why.item3.title": "Southwest Florida coverage",
    "home.why.item3.copy": "Pre-purchase, new build, pre-sale, or insurance — across SWFL and surrounding areas.",
    "home.why.item4.title": "No upsells. Ever.",
    "home.why.item4.copy": "One transparent fee. We don't sell repairs, so our findings are unbiased.",

    // Home — Testimonials
    "home.test.overline": "Voices from our clients",
    "home.test.title": "Trusted across Southwest Florida.",
    "home.test.avg": "5.0 average",
    "home.test.q1": "Detailed, on time, and explained every finding in plain English. Saved us from a roof we would have inherited blind.",
    "home.test.r1.name": "Marisol R.",
    "home.test.r1.role": "Home Buyer · Coral Gables",
    "home.test.q2": "Wind mitigation report knocked $1,400 off our annual premium. Bright FL is now my realtor referral, full stop.",
    "home.test.r2.name": "Daniel K.",
    "home.test.r2.role": "Realtor · Tampa Bay",
    "home.test.q3": "Four-point report was accepted by our insurer the same day. Professional from booking to walkthrough.",
    "home.test.r3.name": "Janelle P.",
    "home.test.r3.role": "Homeowner · Orlando",

    // Home — CTA
    "home.cta.overline": "Ready when you are",
    "home.cta.title1": "Secure your property with an inspection that's actually",
    "home.cta.title2": "thorough",
    "home.cta.body": "Schedule your inspection today — most appointments available within 3 business days.",
    "home.cta.btn1": "Request an appointment",
    "home.cta.btn2": "Talk to us",

    // About
    "about.hero.overline": "About Bright FL Inspections",
    "about.hero.title1": "The standard in",
    "about.hero.title2": "Southwest Florida inspections.",
    "about.hero.body": "We don't just check boxes. We illuminate every system, every defect, every opportunity — so you make decisions with confidence.",
    "about.story.overline": "Meet The Founder",
    "about.story.title1": "Built by Luis Salazar —",
    "about.story.title2": "one home at a time, since 2013.",
    "about.story.p1_after_b": "right FL Inspections was founded in 2013 by Luis Salazar — a one-person operation built on a simple promise: treat every property like it's your own, and tell the homeowner the truth about what they're buying.",
    "about.story.p2": "Luis has called Naples home since 2005, where he lives with his mother Nidia and his daughter Marissa. For him, Southwest Florida isn't just a service area — it's home, and the people who live here are neighbors before they're clients.",
    "about.story.p3": "For over a decade he's walked roofs, crawled attics, and tested systems across Lee, Collier, Charlotte, Hendry, and Sarasota counties — thousands of homes inspected, thousands of buyers and sellers given the clarity they needed to move forward with confidence.",
    "about.story.p4_start": "What he prides himself on more than anything: ",
    "about.story.p4_bold": "integrity",
    "about.story.p4_end": ". Honest work, fair prices, no upsells, no cut corners — every report is something he'd want in his own closing folder.",
    "about.story.cta": "Request appointment",
    "about.values.overline": "What we stand for",
    "about.values.title": "Four standards, never compromised.",
    "about.values.v1.title": "Integrity",
    "about.values.v1.copy": "Honest findings. No upsells. No pressure.",
    "about.values.v2.title": "Precision",
    "about.values.v2.copy": "Documented to the standard insurers require.",
    "about.values.v3.title": "Expertise",
    "about.values.v3.copy": "Certified, insured, continuously trained.",
    "about.values.v4.title": "Communication",
    "about.values.v4.copy": "Plain-language reports, on-site walkthroughs.",
    "about.coverage.overline": "Service Area",
    "about.coverage.title": "Statewide Florida coverage.",
    "about.coverage.body": "Based in SWFL — we serve Lee, Collier, Charlotte, Hendry, Sarasota and the surrounding areas. Locally rooted, neighborhood by neighborhood.",

    // Appointment
    "appt.aside.overline": "Request your inspection",
    "appt.aside.title": "Tell us about your property.",
    "appt.aside.body_pre": "Submit your ",
    "appt.aside.body_strong": "request",
    "appt.aside.body_post": " and we'll personally reach out within one business day to confirm availability. Inspections typically scheduled within 3 business days.",
    "appt.aside.disclaimer_bold": "Please note:",
    "appt.aside.disclaimer": "This is an appointment request, not a confirmed booking. We'll contact you to verify the date and time.",
    "appt.aside.b1": "Confirmation within 1 business day",
    "appt.aside.b2": "On-site walkthrough included",
    "appt.aside.b3": "Photo-rich PDF report in 48 hours",
    "appt.success.title": "Request received.",
    "appt.success.body_pre": "Thanks ",
    "appt.success.body_post": ". We've logged your appointment request and will follow up at ",
    "appt.success.body_post2": " within one business day to confirm.",
    "appt.success.another": "Submit another",
    "appt.step": "Step 01 of 01",
    "appt.heading_mobile": "Request an Appointment",
    "appt.subhead_mobile": "Submit your request — we'll personally confirm within one business day.",
    "appt.disc_mobile_bold": "Heads up:",
    "appt.disc_mobile": "This is a request, not a confirmed booking. We'll reach out to verify the date and time.",
    "appt.field.name": "Full Name *",
    "appt.field.phone": "Phone *",
    "appt.field.email": "Email *",
    "appt.field.address": "Property Address *",
    "appt.field.address_ph": "123 Palm Ave, Naples, FL 34102",
    "appt.field.city": "Property City *",
    "appt.field.city_ph": "Select the city",
    "appt.field.city_other": "Other / Not listed",
    "appt.city_other_help": "Self-scheduling isn't available outside our service map yet. Submit your request below and Luis will reach out personally to coordinate a time.",
    "appt.field.service": "Service *",
    "appt.field.service_ph": "Choose service",
    "appt.field.purpose": "Purpose",
    "appt.field.purpose_ph": "Optional",
    "appt.field.date": "Preferred Date *",
    "appt.field.date_ph": "Pick a date",
    "appt.field.notes": "Notes",
    "appt.field.notes_ph": "Anything we should know — gate codes, pets, specific concerns…",
    "appt.slot.title": "Pick an Available Time *",
    "appt.slot.subtitle_pre": "Showing times that fit Luis's route for ",
    "appt.slot.subtitle_on": " on ",
    "appt.slot.loading": "Checking availability…",
    "appt.slot.none": "No openings on this day given existing appointments and drive time. Try another date — or scroll down and submit a manual request and Luis will follow up.",
    "appt.slot.morning": "Morning",
    "appt.slot.afternoon": "Afternoon",
    "appt.slot.timepref": "Time of Day:",
    "appt.slot.any": "Any",
    "appt.slot.none_pref": "No {pref} slots available for this day. Try a different preference or date.",
    "appt.slot.selected": "Selected:",
    "appt.submit": "Request Appointment",
    "appt.submitting": "Submitting…",
    "appt.disclaimer_bottom": "By submitting you agree to be contacted regarding your inspection request.",

    // Purposes
    "purpose.pre_purchase": "Pre-Purchase",
    "purpose.new_build": "New Build",
    "purpose.pre_sale": "Selling / Pre-Sale",
    "purpose.insurance": "Insurance",

    // Contact
    "contact.hero.overline": "Get in Touch",
    "contact.hero.title1": "Talk to a real",
    "contact.hero.title2": "SWFL inspector.",
    "contact.info.overline": "Contact Details",
    "contact.info.title": "We respond within one business day.",
    "contact.info.email": "Email",
    "contact.info.phone": "Phone",
    "contact.info.area_label": "Service Area",
    "contact.info.area": "Southwest Florida & Surrounding Areas",
    "contact.info.hours_label": "Hours",
    "contact.info.hours": "Mon – Sat · 8am – 6pm",
    "contact.form.overline": "Send a message",
    "contact.form.name": "Name *",
    "contact.form.phone": "Phone",
    "contact.form.email": "Email *",
    "contact.form.message": "Message *",
    "contact.form.message_ph": "Tell us about your property and how we can help…",
    "contact.form.submit": "Send Message",
    "contact.form.sending": "Sending…",
    "contact.success.title": "Message sent.",
    "contact.success.body_pre": "Thanks for reaching out — we'll reply to ",
    "contact.success.body_post": " within one business day.",
    "contact.success.another": "Send another",

    // Toasts
    "toast.fill_required": "Please complete all required fields.",
    "toast.pick_slot": "Please pick an available time slot.",
    "toast.received": "Appointment request received. We'll be in touch shortly!",
    "toast.send_fail": "Submission failed.",
    "toast.contact_fill": "Please complete name, email, and message.",
    "toast.contact_sent": "Message sent. We'll be in touch soon!",
    "toast.contact_fail": "Could not send message. Please try again.",
  },

  es: {
    // Navbar
    "nav.home": "Inicio",
    "nav.about": "Nosotros",
    "nav.appointment": "Solicitar Cita",
    "nav.contact": "Contacto",
    "nav.cta_appointment": "Solicitar Cita",

    // Footer
    "footer.tagline": "Iluminando cada rincón de su inversión.",
    "footer.subtitle": "Inspecciones residenciales licenciadas y aseguradas en el suroeste de Florida y áreas circundantes.",
    "footer.navigate": "Navegar",
    "footer.contact": "Contacto",
    "footer.area": "Suroeste de Florida y Áreas Circundantes",
    "footer.rights": "Todos los derechos reservados.",
    "footer.creds": "Licenciado en FL • Asegurado • Certificado",

    // Home — Hero
    "home.hero.overline": "Iluminando Su Inversión",
    "home.hero.title1": "Inspecciones de",
    "home.hero.title2": "casa en Florida,",
    "home.hero.title3": "hechas bien.",
    "home.hero.subtitle": "Bright FL Inspections ofrece reportes minuciosos y profesionales para propietarios, compradores y aseguradoras en el suroeste de Florida.",
    "home.hero.cta1": "Solicitar una Cita",
    "home.hero.cta2": "Nuestros Servicios",
    "home.hero.badge1": "Licenciado y Asegurado",
    "home.hero.badge2": "Inspector Certificado",
    "home.hero.badge3": "Reportes en 48 hrs",
    "home.hero.badge4": "Sirviendo SWFL",

    // Home — Services
    "home.services.overline": "Lo que inspeccionamos",
    "home.services.title": "Cada reporte. Cada ángulo. Siempre.",
    "home.services.cta": "Obtener Cotización",
    "home.services.4pt.tag": "Listo para Seguro",
    "home.services.4pt.title": "Inspección de Cuatro Puntos",
    "home.services.4pt.copy": "Techo, eléctrico, plomería y aire acondicionado — los cuatro pilares que las aseguradoras requieren para casas de 25+ años.",
    "home.services.wind.tag": "Ahorre en Primas",
    "home.services.wind.title": "Mitigación de Viento",
    "home.services.wind.copy": "Documentamos características resistentes al viento para obtener descuentos importantes en su seguro.",
    "home.services.full.tag": "Más Completa",
    "home.services.full.title": "Inspección Completa de Casa",
    "home.services.full.copy": "Evaluación de propiedad de arriba a abajo — para compradores, vendedores y construcciones nuevas.",
    "home.services.roof.tag": "Certificado de Condición del Techo",
    "home.services.roof.title": "Inspección de Techo",
    "home.services.roof.copy": "Reportes de techo que las aseguradoras aceptan — con el detalle que se requiere.",

    // Home — Why
    "home.why.overline": "Por qué Bright FL",
    "home.why.title1": "Precisión sobre",
    "home.why.title2": "papeleo.",
    "home.why.body": "Nos basamos en una promesa simple: cada inspección la tratamos como si fuera nuestra propia casa. Detallada. Honesta. A tiempo.",
    "home.why.item1.title": "Recorrido en sitio el mismo día",
    "home.why.item1.copy": "Repasamos cada hallazgo con usted antes de irnos de la propiedad.",
    "home.why.item2.title": "Reportes en 48 horas o menos",
    "home.why.item2.copy": "PDFs claros y con fotos — listos para compradores, vendedores y aseguradoras.",
    "home.why.item3.title": "Cobertura en el suroeste de Florida",
    "home.why.item3.copy": "Pre-compra, construcción nueva, pre-venta o seguro — en SWFL y áreas circundantes.",
    "home.why.item4.title": "Sin ventas adicionales. Nunca.",
    "home.why.item4.copy": "Una tarifa transparente. No vendemos reparaciones, así nuestros hallazgos son imparciales.",

    // Home — Testimonials
    "home.test.overline": "Voces de nuestros clientes",
    "home.test.title": "Confiado en todo el suroeste de Florida.",
    "home.test.avg": "5.0 promedio",
    "home.test.q1": "Detallado, puntual, y nos explicó cada hallazgo de forma sencilla. Nos salvó de heredar un techo a ciegas.",
    "home.test.r1.name": "Marisol R.",
    "home.test.r1.role": "Compradora · Coral Gables",
    "home.test.q2": "El reporte de mitigación de viento le quitó $1,400 a nuestra prima anual. Bright FL es ahora mi referencia como agente, punto.",
    "home.test.r2.name": "Daniel K.",
    "home.test.r2.role": "Agente · Tampa Bay",
    "home.test.q3": "El reporte de cuatro puntos fue aceptado por nuestra aseguradora el mismo día. Profesional de principio a fin.",
    "home.test.r3.name": "Janelle P.",
    "home.test.r3.role": "Propietaria · Orlando",

    // Home — CTA
    "home.cta.overline": "Listos cuando usted lo esté",
    "home.cta.title1": "Asegure su propiedad con una inspección que realmente sea",
    "home.cta.title2": "minuciosa",
    "home.cta.body": "Agende su inspección hoy — la mayoría de las citas disponibles en 3 días hábiles.",
    "home.cta.btn1": "Solicitar una cita",
    "home.cta.btn2": "Háblenos",

    // About
    "about.hero.overline": "Acerca de Bright FL Inspections",
    "about.hero.title1": "El estándar en",
    "about.hero.title2": "inspecciones del suroeste de Florida.",
    "about.hero.body": "No solo revisamos casillas. Iluminamos cada sistema, cada defecto, cada oportunidad — para que tome decisiones con confianza.",
    "about.story.overline": "Conozca al Fundador",
    "about.story.title1": "Construido por Luis Salazar —",
    "about.story.title2": "una casa a la vez, desde 2013.",
    "about.story.p1_after_b": "right FL Inspections fue fundada en 2013 por Luis Salazar — una operación de una sola persona, basada en una promesa simple: tratar cada propiedad como si fuera la suya, y decirle al dueño la verdad sobre lo que está comprando.",
    "about.story.p2": "Luis vive en Naples desde 2005, donde reside con su madre Nidia y su hija Marissa. Para él, el suroeste de Florida no es solo un área de servicio — es su hogar, y los que viven aquí son vecinos antes que clientes.",
    "about.story.p3": "Por más de una década ha caminado techos, recorrido áticos y probado sistemas en los condados de Lee, Collier, Charlotte, Hendry y Sarasota — miles de casas inspeccionadas, miles de compradores y vendedores con la claridad para avanzar con confianza.",
    "about.story.p4_start": "De lo que más se enorgullece: ",
    "about.story.p4_bold": "integridad",
    "about.story.p4_end": ". Trabajo honesto, precios justos, sin ventas adicionales, sin atajos — cada reporte es algo que él mismo querría en su propio expediente.",
    "about.story.cta": "Solicitar cita",
    "about.values.overline": "Lo que defendemos",
    "about.values.title": "Cuatro estándares, nunca comprometidos.",
    "about.values.v1.title": "Integridad",
    "about.values.v1.copy": "Hallazgos honestos. Sin ventas adicionales. Sin presión.",
    "about.values.v2.title": "Precisión",
    "about.values.v2.copy": "Documentado al estándar que las aseguradoras requieren.",
    "about.values.v3.title": "Experiencia",
    "about.values.v3.copy": "Certificado, asegurado, en formación continua.",
    "about.values.v4.title": "Comunicación",
    "about.values.v4.copy": "Reportes en lenguaje claro, recorridos en sitio.",
    "about.coverage.overline": "Área de Servicio",
    "about.coverage.title": "Cobertura en el suroeste de Florida.",
    "about.coverage.body": "Basados en SWFL — servimos a Lee, Collier, Charlotte, Hendry, Sarasota y áreas circundantes. Arraigados localmente, vecindario por vecindario.",

    // Appointment
    "appt.aside.overline": "Solicite su inspección",
    "appt.aside.title": "Cuéntenos sobre su propiedad.",
    "appt.aside.body_pre": "Envíe su ",
    "appt.aside.body_strong": "solicitud",
    "appt.aside.body_post": " y nos comunicaremos con usted personalmente dentro de un día hábil para confirmar disponibilidad. Inspecciones típicamente agendadas en 3 días hábiles.",
    "appt.aside.disclaimer_bold": "Tenga en cuenta:",
    "appt.aside.disclaimer": "Esta es una solicitud de cita, no una reserva confirmada. Lo contactaremos para verificar la fecha y hora.",
    "appt.aside.b1": "Confirmación dentro de 1 día hábil",
    "appt.aside.b2": "Recorrido en sitio incluido",
    "appt.aside.b3": "Reporte PDF con fotos en 48 horas",
    "appt.success.title": "Solicitud recibida.",
    "appt.success.body_pre": "Gracias ",
    "appt.success.body_post": ". Hemos registrado su solicitud y le responderemos a ",
    "appt.success.body_post2": " dentro de un día hábil para confirmar.",
    "appt.success.another": "Enviar otra",
    "appt.step": "Paso 01 de 01",
    "appt.heading_mobile": "Solicitar una Cita",
    "appt.subhead_mobile": "Envíe su solicitud — confirmaremos personalmente dentro de un día hábil.",
    "appt.disc_mobile_bold": "Atención:",
    "appt.disc_mobile": "Esta es una solicitud, no una reserva confirmada. Lo contactaremos para verificar la fecha y hora.",
    "appt.field.name": "Nombre Completo *",
    "appt.field.phone": "Teléfono *",
    "appt.field.email": "Correo *",
    "appt.field.address": "Dirección de la Propiedad *",
    "appt.field.address_ph": "123 Palm Ave, Naples, FL 34102",
    "appt.field.city": "Ciudad de la Propiedad *",
    "appt.field.city_ph": "Seleccione la ciudad",
    "appt.field.city_other": "Otra / No listada",
    "appt.city_other_help": "Auto-programación no está disponible fuera de nuestro mapa de servicio aún. Envíe su solicitud abajo y Luis lo contactará personalmente para coordinar.",
    "appt.field.service": "Servicio *",
    "appt.field.service_ph": "Elija servicio",
    "appt.field.purpose": "Propósito",
    "appt.field.purpose_ph": "Opcional",
    "appt.field.date": "Fecha Preferida *",
    "appt.field.date_ph": "Elija una fecha",
    "appt.field.notes": "Notas",
    "appt.field.notes_ph": "Algo que debamos saber — códigos de puerta, mascotas, inquietudes específicas…",
    "appt.slot.title": "Elija un Horario Disponible *",
    "appt.slot.subtitle_pre": "Mostrando horarios que se ajustan a la ruta de Luis para ",
    "appt.slot.subtitle_on": " el ",
    "appt.slot.loading": "Verificando disponibilidad…",
    "appt.slot.none": "No hay horarios disponibles este día dada la agenda y los tiempos de traslado. Pruebe otra fecha — o envíe una solicitud manual abajo y Luis le responderá.",
    "appt.slot.morning": "Mañana",
    "appt.slot.afternoon": "Tarde",
    "appt.slot.timepref": "Hora del Día:",
    "appt.slot.any": "Cualquiera",
    "appt.slot.none_pref": "No hay horarios de {pref} disponibles este día. Pruebe otra preferencia o fecha.",
    "appt.slot.selected": "Seleccionado:",
    "appt.submit": "Solicitar Cita",
    "appt.submitting": "Enviando…",
    "appt.disclaimer_bottom": "Al enviar acepta ser contactado sobre su solicitud de inspección.",

    // Purposes
    "purpose.pre_purchase": "Pre-Compra",
    "purpose.new_build": "Construcción Nueva",
    "purpose.pre_sale": "Vendiendo / Pre-Venta",
    "purpose.insurance": "Seguro",

    // Contact
    "contact.hero.overline": "Póngase en Contacto",
    "contact.hero.title1": "Hable con un inspector",
    "contact.hero.title2": "real de SWFL.",
    "contact.info.overline": "Datos de Contacto",
    "contact.info.title": "Respondemos dentro de un día hábil.",
    "contact.info.email": "Correo",
    "contact.info.phone": "Teléfono",
    "contact.info.area_label": "Área de Servicio",
    "contact.info.area": "Suroeste de Florida y Áreas Circundantes",
    "contact.info.hours_label": "Horario",
    "contact.info.hours": "Lun – Sáb · 8am – 6pm",
    "contact.form.overline": "Envíe un mensaje",
    "contact.form.name": "Nombre *",
    "contact.form.phone": "Teléfono",
    "contact.form.email": "Correo *",
    "contact.form.message": "Mensaje *",
    "contact.form.message_ph": "Cuéntenos sobre su propiedad y cómo podemos ayudar…",
    "contact.form.submit": "Enviar Mensaje",
    "contact.form.sending": "Enviando…",
    "contact.success.title": "Mensaje enviado.",
    "contact.success.body_pre": "Gracias por contactarnos — responderemos a ",
    "contact.success.body_post": " dentro de un día hábil.",
    "contact.success.another": "Enviar otro",

    // Toasts
    "toast.fill_required": "Por favor complete todos los campos requeridos.",
    "toast.pick_slot": "Por favor elija un horario disponible.",
    "toast.received": "Solicitud de cita recibida. ¡Nos comunicaremos pronto!",
    "toast.send_fail": "Envío fallido.",
    "toast.contact_fill": "Por favor complete nombre, correo y mensaje.",
    "toast.contact_sent": "Mensaje enviado. ¡Nos comunicaremos pronto!",
    "toast.contact_fail": "No se pudo enviar el mensaje. Intente de nuevo.",
  },
};
